module.exports = __webpack_public_path__ + "79138272e475e2be6ebc30a6e2c7f092.png";